import "../style/store/S_Filter.css";
import { HiOutlineFilter } from "react-icons/hi";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../redux/index";
import { useEffect } from "react";

let data_list = [
  {
    id: 1,
    tag: "همه",
    isActive: true,
    style: {
      border: "1px solid #2E81E8",
      backgroundColor: "#EBF6FF",
      color: "#2E81E8",
    },
    type: "all",
  },
  {
    id: 2,
    tag: "پایه تحصیلی",
    isActive: false,
    style: {
      border: "1px solid #2E81E8",
      backgroundColor: "#EBF6FF",
      color: "#2E81E8",
    },
    type: "level",
  },
  {
    id: 3,
    tag: "تخفیف خورده",
    isActive: false,
    style: {
      border: "1px solid #2E81E8",
      backgroundColor: "#EBF6FF",
      color: "#2E81E8",
    },
    type: "discounted",
  },
  {
    id: 4,
    tag: "رایگان",
    isActive: false,
    style: {
      border: "1px solid #2E81E8",
      backgroundColor: "#EBF6FF",
      color: "#2E81E8",
    },
    type: "free",
  },
];

const S_Filter = () => {
  const [data, set_data] = useState(data_list);
  const [oldActive, set_oldActive] = useState(1);

  const dispatch = useDispatch();
  const { productChangeFilter } = bindActionCreators(actionCreators, dispatch);

  useEffect(() => {
    for (let i = 0; i < data_list.length; i++) {
      if (i === 0) {
        data_list[0].isActive = true;
      } else {
        data_list[i].isActive = false;
      }
    }
    set_data(data_list);
    productChangeFilter("all");
  }, []);

  const changer_filter = (id) => {
    let new_data = data.map((item) => {
      if (item.id === oldActive) {
        item.isActive = false;
      }
      if (item.id === id) {
        item.isActive = true;
        productChangeFilter(item.type);
      }
      return { ...item };
    });
    set_oldActive(id);
    set_data(new_data);
  };

  return (
    <div className="s-filter">
      <div className="s-filter-title-box">
        <HiOutlineFilter className="sftb-icon" />
        <div className="sftb-title">دسته‌بندی</div>
      </div>
      <div className="s_filter_tag_container">
        {data.map((item) => (
          <div
            style={item.isActive ? item.style : null}
            key={item.id}
            className="sftc-item"
            onClick={() => changer_filter(item.id)}
          >
            {item.tag}
          </div>
        ))}
      </div>
    </div>
  );
};

export default S_Filter;
